import React from 'react';
import { useAppSelector } from '../../../app/hooks';
import PortfolioComposite from '../../../api/models/portfolioComposite';
import { selectChildrenPositionRecursively } from './portfolio-detail-slice';
import PortfolioDetailPositionCard from './portfolio-detail-position-card';

interface PortfolioDetailPositionsProps {
  portfolioComposite: PortfolioComposite
}

/**
 * A summary of the portfolio.
 */
const PortfolioDetailPositions: React.FC<PortfolioDetailPositionsProps> = (props: PortfolioDetailPositionsProps) => {

  // Get the 'dispatch' method from the store
  const positions = useAppSelector(selectChildrenPositionRecursively);

  return (
    <div className='flex flex-col items-center w-full h-full'>
      <div className='lg:hidden flex flex-row w-full h-8 py-3 items-center'>
        <div className='grow flex flex-col [mask-image:linear-gradient(to_right,transparent_0,black_150px,black_100%)]'>
          <div className='h-1/2 mx-3 border-b border-blue-300/40'></div>
          <div className='h-1/2 mx-3'></div>
        </div>
        <label className='text-base'>Posições</label>
        <div className='grow flex flex-col [mask-image:linear-gradient(to_right,black_0,black_calc(100%-150px),transparent_100%)]'>
          <div className='h-1/2 mx-3 border-b border-blue-300/40'></div>
          <div className='h-1/2 mx-3'></div>
        </div>
      </div>
      <div className='flex flex-col items-center w-full h-full px-8 lg:py-9'>
        <label className='max-lg:hidden text-2xl'>Posições</label>
        <label className='lg:hidden pb-10 text-xs'>(toque nelas para detalhar)</label>
        <label className='max-lg:hidden pb-10 text-base'>(clique nelas para detalhar)</label>
        <div className='grow w-full grid grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-20 pb-9'>
          {
            positions.map(position => {
              return <PortfolioDetailPositionCard
                key={position.id}
                position={position}
              />
            })
          }
        </div>
      </div>
    </div>
  )
}

export default PortfolioDetailPositions;